import fetch from "auth/FetchInterceptor";

const SalariesService = {};

const salariesPrefix = "/salaries";

// Obtenir toutes les données de salaires
SalariesService.getSalaries = async () =>
  await fetch(`${salariesPrefix}/`, {
    method: "GET",
  });

// Obtenir un salaire par ID
SalariesService.getSalaryById = async (id) =>
  await fetch(`${salariesPrefix}/${id}`, {
    method: "GET",
  });

// Obtenir le salaire d'un instructeur spécifique
SalariesService.getInstructorSalary = async (instructorId) =>
  await fetch(`${salariesPrefix}/instructor/${instructorId}`, {
    method: "GET",
  });

// Effectuer un paiement à un instructeur
SalariesService.payInstructor = async (data) =>
  await fetch(`${salariesPrefix}/`, {
    method: "POST",
    data,
  });

export default SalariesService;